var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Box, Optional } from '@honda-canada/design-system-react';
import ConfigurationProvider from './service/Provider';
import Exterior360View from './Exterior360View';
import Interior360View from './Interior360View';
import { availableAssetTypes } from '../ThreeSixtyView/useAssets';
var ThreeSixtyImageViewUI = function (_a) {
    var interiorAsset = _a.interiorAsset, exteriorAsset = _a.exteriorAsset, exteriorAssetColor = _a.exteriorAssetColor, interiorAssetColor = _a.interiorAssetColor, assetType = _a.assetType, dataTestId = _a.dataTestId, gtmVehicleData = _a.gtmVehicleData, accessoriesWithOverlayImages = _a.accessoriesWithOverlayImages, hasInteriorColors = _a.hasInteriorColors;
    var isExterior = assetType.toLowerCase() === availableAssetTypes.exterior.toLowerCase();
    var dataTestIdMain = dataTestId ? "cy-".concat(dataTestId, "-threeSixty-image") : 'cy-threeSixty-image';
    var boxStyles = { width: '100%', height: '100%' };
    if (exteriorAsset === undefined)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Optional, { when: isExterior },
            React.createElement(Box, __assign({ "data-testid": "".concat(dataTestIdMain, "-exterior-wrapper"), display: isExterior ? 'block' : 'none' }, boxStyles),
                React.createElement(Exterior360View, { images: exteriorAsset, accessoriesWithOverlayImages: accessoriesWithOverlayImages, assetColor: exteriorAssetColor, gtmVehicleData: gtmVehicleData }))),
        React.createElement(Optional, { when: !isExterior && hasInteriorColors },
            React.createElement(Box, __assign({ "data-testid": "".concat(dataTestIdMain, "-interior-wrapper"), display: !isExterior ? 'block' : 'none' }, boxStyles),
                React.createElement(Interior360View, { assetColor: interiorAssetColor, images: interiorAsset, assetType: assetType, gtmVehicleData: gtmVehicleData })))));
};
var ThreeSixtyImageView = function (_a) {
    var appNameConfig = _a.appNameConfig, gtmVehicleData = _a.gtmVehicleData, hasInteriorColors = _a.hasInteriorColors, restProps = __rest(_a, ["appNameConfig", "gtmVehicleData", "hasInteriorColors"]);
    return (React.createElement(ConfigurationProvider, { appNameConfig: appNameConfig },
        React.createElement(ThreeSixtyImageViewUI, __assign({ gtmVehicleData: gtmVehicleData }, restProps, { hasInteriorColors: hasInteriorColors }))));
};
export default ThreeSixtyImageView;
